import { BarcodeScannerFormat, BarcodeScannerFormatKind } from '../types'
import { toFormatKind } from './to-format-kind'

export const isFormatKindApplicable = (
  formats: BarcodeScannerFormat[],
  formatKind: BarcodeScannerFormatKind
): boolean => formats.some((format) => toFormatKind(format) === formatKind)
